import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import CategoryDropdown from "./CategoryDropdown";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { lang } = useParams();
  const navigate = useNavigate();
  const { i18n,t } = useTranslation();

  const switchLanguage = (code) => {
    if (lang !== code) {
      navigate(`/cm/${code}`);
    }
  };

  return (
    <header className="bg-green-500 text-white shadow-lg">
      <nav className="container mx-auto flex items-center justify-between p-4">
        {/* Logo */}
        <h1 className="text-2xl font-bold tracking-wide">
          <Link to={`/cm/${lang}`} className="flex items-center gap-2 text-2xl font-extrabold">
            <img src="https://proprimemart.com/237mechanic_real_logo.png" alt="237Mechanic Logo" className="h-20 w-auto" />
          </Link>
        </h1>

        {/* Language Dropdown (Desktop) */}
        <div className="hidden md:block relative">
          <select
            value={lang}
            onChange={(e) => switchLanguage(e.target.value)}
            className="text-black px-3 py-1 rounded shadow bg-white"
          >
            {LANGUAGES.map(({ code, label, flag }) => (
              <option key={code} value={code}>
                {flag} {label}
              </option>
            ))}
          </select>
        </div>

        {/* Hamburger Menu (Mobile) */}
        <div className="md:hidden">
          <button
            className="text-white focus:outline-none"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Navigation Links */}
        <ul
          className={`md:flex space-x-6 ${
            menuOpen ? "block" : "hidden"
          } absolute md:relative md:block bg-black md:bg-transparent w-full md:w-auto top-16 md:top-auto left-0 z-20`}
        >
          <li>
            <Link to={`/cm/${lang}`} className="block px-4 py-2 hover:text-gray-400">
              {t("nav.home")}
            </Link>
          </li>
          <li>
            <Link to={`/cm/${lang}/about-us`} className="block px-4 py-2 hover:text-gray-400">
              {t("nav.about")}
            </Link>
          </li>
          <li>
            <Link to={`/cm/${lang}/contact-us`} className="block px-4 py-2 hover:text-gray-400">
              {t("nav.contact")}
            </Link>
          </li>
          <li>
            <Link to={`/cm/${lang}/shop`} className="block px-4 py-2 hover:text-gray-400">
              {t("nav.shop")}
            </Link>
          </li>
          <li>
            <CategoryDropdown />
          </li>

          {/* Mobile Language Dropdown */}
          <li className="md:hidden px-4 py-2">
            <select
              value={lang}
              onChange={(e) => switchLanguage(e.target.value)}
              className="text-black w-full px-3 py-1 rounded shadow bg-white"
            >
              {LANGUAGES.map(({ code, label, flag }) => (
                <option key={code} value={code}>
                  {flag} {label}
                </option>
              ))}
            </select>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
